
import { declareVrunComponent } from '/vodalys/vvuejs/declareVrunComponent.mjs'

import TroubleshootingApp from './TroubleshootingApp.vue'

declareVrunComponent('troubleshootingApp.vrun.component', TroubleshootingApp)